import { createSlice } from '@reduxjs/toolkit';
import { loginUser, loginWithSocial } from '../actions/loginAction';

import { registerUser } from '../actions/registerAction';

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  data: null,
  user: JSON.parse(localStorage.getItem('user')) || null,
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token'),
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetLoginState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.data = null;
      state.status = null;
    },
    setSocialUser: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token || 'social_login_placeholder';
      state.isAuthenticated = true;
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      const token = action.payload.token || 'social_login_placeholder';
      localStorage.setItem('token', token);
      localStorage.setItem('userTools', JSON.stringify({
        token: token,
        user: action.payload.user
      }));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.data = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userTools');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
        state.user = action.payload.data?.user || null;
        state.token = action.payload.data?.token || null;
        state.isAuthenticated = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
       
        state.isLoading = false;
        state.error = action.payload || 'Something went wrong';
        state.success = false;
      })
      .addCase(loginWithSocial.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(loginWithSocial.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
        state.user = action.payload.data?.user || null;
        state.token = action.payload.data?.token || null;
        state.isAuthenticated = true;
      })
      .addCase(loginWithSocial.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Something went wrong';
        state.success = false;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        if (action.payload.data?.token) {
          state.user = action.payload.data?.user || null;
          state.token = action.payload.data?.token || null;
          state.isAuthenticated = true;
        }
      });
  },
});

export const { resetLoginState, logout, setSocialUser } = loginSlice.actions;
export default loginSlice.reducer;
